import { render, staticRenderFns } from "./add_custom_vanables.vue?vue&type=template&id=3959ab86&scoped=true&"
import script from "./add_custom_vanables.vue?vue&type=script&lang=js&"
export * from "./add_custom_vanables.vue?vue&type=script&lang=js&"
import style0 from "./add_custom_vanables.vue?vue&type=style&index=0&id=3959ab86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3959ab86",
  null
  
)

export default component.exports